(function (app) {
    app.constant("_householdRelationshipTypes",
    [
        { ShortName: "Spouse", LongName: "Spouse", Opposite: "Spouse" },
        { ShortName: "Sibling", LongName: "Sibling", Opposite: "Sibling" },
        { ShortName: "Parent", LongName: "Parent", Opposite: "Child" },
        { ShortName: "Child", LongName: "Child", Opposite: "Parent" },
        { ShortName: "Other", LongName: "Other", Opposite: "Other" },
        { ShortName: "Grandparent", LongName: "Grandparent", Opposite: "Grandchild" },
        { ShortName: "Grandchild", LongName: "Grandchild", Opposite: "Grandparent" },
        { ShortName: "SiblingChild", LongName: "Niece/Nephew", Opposite: "ParentSibling" },
        { ShortName: "ParentSibling", LongName: "Aunt/Uncle", Opposite: "SiblingChild" },
        { ShortName: "SignificantOther", LongName: "Significant Other", Opposite: "SignificantOther" }
    ]);
})(window.app); //jshint ignore:line